const DebugActionType = {
    INIT_INSTANCE: 'InitInstance'
}
export default DebugActionType
